/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type AdviserLinkResponseDto = {
    /**
     * Adviser link ID
     */
    id: string;
    /**
     * Client ID
     */
    clientId: string;
    /**
     * Type of adviser link
     */
    linkType: AdviserLinkResponseDto.linkType;
    /**
     * Adviser ID (Adviser entity ID)
     */
    adviserId: string;
    /**
     * Adviser User ID (for frontend navigation to adviser detail page)
     */
    adviserUserId?: string;
    /**
     * Adviser name
     */
    adviserName: string;
    /**
     * FAP ID
     */
    fapId: string;
    /**
     * FAP name
     */
    fapName: string;
    /**
     * Effective from date
     */
    effectiveFrom: string;
    /**
     * Effective to date (null if ongoing)
     */
    effectiveTo?: string;
    /**
     * Commission recipient type
     */
    commissionRecipient: AdviserLinkResponseDto.commissionRecipient;
    /**
     * Status of the adviser link
     */
    status: AdviserLinkResponseDto.status;
    /**
     * Reason for this adviser link
     */
    reason?: string;
    /**
     * User ID who made the change
     */
    changedBy: string;
    /**
     * Display name of the user who made the change
     */
    changedByName?: string;
    /**
     * Date when the change was made
     */
    changedAt: string;
    /**
     * Creation date
     */
    createdAt: string;
    /**
     * Last update date
     */
    updatedAt: string;
};
export namespace AdviserLinkResponseDto {
    /**
     * Type of adviser link
     */
    export enum linkType {
        AUTHORISED_REP = 'AUTHORISED_REP',
        SERVICING_ADVISER = 'SERVICING_ADVISER',
    }
    /**
     * Commission recipient type
     */
    export enum commissionRecipient {
        ADVISER = 'ADVISER',
        FAP = 'FAP',
        INHERIT = 'INHERIT',
    }
    /**
     * Status of the adviser link
     */
    export enum status {
        CURRENT = 'CURRENT',
        HISTORICAL = 'HISTORICAL',
    }
}

